import { MuiThemeProvider } from 'material-ui/styles/';
import { inject, Provider } from 'mobx-react';
import * as React from 'react';
import { Switch } from 'react-router';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import './assets/styles/App.css';
import { theme } from './assets/Theme';
import { CONSTANTS } from './assets/UIConstants';
import { ApplicationStore } from './data_layer/stores/ApplicationStore';
import CustomButton from './views/components/Button';
import TextInput from './views/components/TextInput';
import { NavigationController } from './views/NavigationController';
import { LogIn } from './views/pages/LogIn';
import { Public } from './views/pages/Public';

const store = new ApplicationStore();

type Props = {
    store?: ApplicationStore;
};

class App extends React.Component<Props> {
    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <Provider store={store}>
                    <Router>
                        <div className="App">
                            <Switch>
                                <Route exact={true} path="/public" component={Public} />
                                <Route exact={true} path="/login" component={LogIn} />
                                <Route exact={true} path="/resetPassword" component={ResetPasswordPage} />
                                <Route component={NavigationController} />
                            </Switch>
                        </div>
                    </Router>
                </Provider>
            </MuiThemeProvider>
        );
    }
}

export default App;

@inject('store')
export class ResetPasswordPage extends React.Component<{ store: ApplicationStore }, { email: string; passwordWasReset: boolean }> {
    public state = {
        email: '',
        passwordWasReset: false,
    };

    private resetPassword = (): void => {
        this.setState({ passwordWasReset: true });
        this.props.store.authorizationStore.resetPassword(this.state.email);
    };

    public render(): JSX.Element {
        if (this.state.passwordWasReset) {
            return (
                <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                    <p>{'A password reset email was sent to ' + this.state.email}</p>

                    <CustomButton
                        onClick={() => (this.props as any).history.push('/login')}
                        type={'submit'}
                        isPrimary={true}
                        style={{ border: 'none', boxShadow: CONSTANTS.BOX_SHADOW.LOGIN_BUTTONS, textTransform: 'none', marginTop: 20 }}
                    >
                        Go back
                    </CustomButton>
                </div>
            );
        }
        return (
            <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                <p>{'Forgot Password?'}</p>

                <TextInput
                    label={'Email'}
                    placeholder={'email'}
                    id={'user_name'}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        this.setState({ email: e.target.value });
                    }}
                />

                <CustomButton
                    onClick={this.resetPassword}
                    type={'submit'}
                    isPrimary={true}
                    style={{ border: 'none', boxShadow: CONSTANTS.BOX_SHADOW.LOGIN_BUTTONS, textTransform: 'none', marginTop: 20 }}
                >
                    Send Password Reset Email
                </CustomButton>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx